import Highlight, { defaultProps } from "prism-react-renderer";
import theme from "prism-react-renderer/themes/nightOwl";
import { Pre, Line, LineNo, LineContent } from "./styles";

// JS Sample Code
const javascript = `const crypto = require('crypto'); const encryptionType = 'aes-256-cbc'; const encryptionEncoding = 'base64'; const bufferEncryption = 'utf-8'; const AesKey = getCache("AesKey "); const AesIV = getCache("AesIV ");
 
const encrypt = (jsonObject) => {
    const val = JSON.stringify(jsonObject);
    const key = Buffer.from(AesKey, bufferEncryption); const iv = Buffer.from(AesIV, bufferEncryption);
    const cipher = crypto.createCipheriv(encryptionType, key, iv);
    let encrypted = cipher.update(val, bufferEncryption, encryptionEncoding); encrypted += cipher.final(encryptionEncoding);
    return encrypted;
}
const encryptFile = (filePath) => {
    const data = fs.readFileSync(filePath);
    let base64Image = Buffer.from(data, 'binary').toString('base64');
    let encryptedData = encrypt(base64Image); return encryptedData;
}
const encryptFormData = (body) => {
    jsEncrypt.setPublicKey(getCache("accountOpeningRSAPublicKey")); var data = new FormData();
for (let key in body)
    {
        if (/
        /.test(bodykey))
        {
            let encryptedFile = encryptFile(bodykey); data.append(key, encryptedFile);
        }
        else
        {
            if (Array.isArray(bodykey) && bodykey.every(i => (typeof i === "string")))
            {
                let arrayOfElements = bodykey; let arrayOfEncryptedElements = [];
for (let element in arrayOfElements)
                {
 
                    let encryptedData = jsEncrypt.encrypt(arrayOfElementselement).toString();
                    arrayOfEncryptedElements.push(encryptedData);
                }
                data.append(key, JSON.stringify(arrayOfEncryptedElements));
            }
            else if (Array.isArray(bodykey))
            {
                let arrayOfElements = bodykey; let arrayOfEncryptedElements = [];
for (let element in arrayOfElements)
                {
                    let model = { };
                    let unencryptedModel = arrayOfElementselement; for (let jKey in unencryptedModel)
                    {
                        let dataToEncrypt = unencryptedModeljKey.toString(); let encryptedData =
                        jsEncrypt.encrypt(dataToEncrypt).toString();
                        modeljKey = encryptedData;
                    }
                    arrayOfEncryptedElements.push(model);
                }
                data.append(key, JSON.stringify(arrayOfEncryptedElements));
            }
            else
            {
                console.log(key + bodykey);
                let dataToEncrypt = bodykey.toString(); if (dataToEncrypt.includes("Object"))
                    dataToEncrypt = JSON.stringify(bodykey);
                data.append(key, jsEncrypt.encrypt(dataToEncrypt).toString());
            }
        }
    }
    return data;
}`;

function EFDAAF() {
  return (
    <Highlight
      {...defaultProps}
      theme={theme}
      code={javascript}
      language="javascript"
    >
      {({ className, style, tokens, getLineProps, getTokenProps }) => (
        <Pre className={className} style={style}>
          {tokens.map((line, i) => (
            <Line key={i} {...getLineProps({ line, key: i })}>
              <LineNo>{i + 1}</LineNo>
              <LineContent>
                {line.map((token, key) => (
                  <span key={key} {...getTokenProps({ token, key })} />
                ))}
              </LineContent>
            </Line>
          ))}
        </Pre>
      )}
    </Highlight>
  );
}
export default EFDAAF;
